import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  COURSE_FEATURE_KEY,
  CourseState,
  courseAdapter,
} from './course.reducer';
import { AutocompleteOption } from '@lyceo/shared/util-models';
import { Course } from '@lyceo/shared/plan/util-models';

export const selectCourseState =
  createFeatureSelector<CourseState>(COURSE_FEATURE_KEY);

const { selectAll } = courseAdapter.getSelectors();

export const selectAllCourses = createSelector(
  selectCourseState,
  (state: CourseState) => selectAll(state),
);

export const selectAllCoursesAsOptions = createSelector(
  selectAllCourses,
  (courses) =>
    courses.map(
      (course): AutocompleteOption<Course> => ({
        value: course.id,
        label: course.name,
        meta: course,
      }),
    ),
);
